import { all } from 'redux-saga/effects';
import announcementWatcher from './announcementSaga';

export default function* rootSaga(action) {
	yield all([announcementWatcher(action)]);
}
